import * as React from 'react'
import { View } from 'react-native'
import Svg, { Circle, Ellipse, Path } from 'react-native-svg'
import type { SvgProps } from 'react-native-svg'

export const SvgHappy = (props: SvgProps) => (
  <View>
    {
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        data-name="Layer 1"
        viewBox="0 0 471.644 535.279"
        {...props}
      >
        <Path
          fill="#f2f2f2"
          d="M303.222 396.304a5.853 5.853 0 0 0 8.195-7.332l.324-1.612a15.726 15.726 0 0 1 26.436 12.296c-.725 17.643.147 36.68-11.58 50.903 53.52-43.734 77.923-118.237 61.579-185.245-8.02-11.175-11.761-26.021-8.165-39.474 4.513 4.39 13.311 3.21 11.967-4.388-.722-3.004-1.468-5.998-2.19-9 30.826-12.03 38.874 33.805 2.36 52.467a187.67 187.67 0 0 1 4.84 38.83 78.907 78.907 0 0 1 20.024-31.057c8.75-7.879 20.322-12.512 31.087-17.798 13.099-6.45 27.637 6.336 22.479 19.986-8.72-1.116-14.89 9.307-6.977 14.908-13.898 23.341-40.547 38.177-67.623 38.413a188.401 188.401 0 0 1-24.592 75.516c17.297-26.302 50.77-18.729 77.224-19.85a9.114 9.114 0 0 1 8.575 14.314 52.642 52.642 0 0 0-10.424.424 7.956 7.956 0 0 0-2.913 14.701c-23.206 21.274-59.164 25.847-87.385 12.272a193.688 193.688 0 0 1-28.09 28.689l-41.956-20c.071-.538.166-1.084.252-1.615a52.809 52.809 0 0 0 11.94 4.842c-4.476-17.063-9.464-27.057 4.612-41.19ZM229.084 355.94a5.853 5.853 0 0 1-10.355-3.7l-.909-1.37a15.726 15.726 0 0 0-19.844 21.36c7.326 16.066 13.7 34.025 29.925 42.774-66.063-20.315-116.766-80.11-126.905-148.333 3.212-13.375 1.077-28.535-7.328-39.638-2.524 5.768-11.117 7.994-12.738.45-.465-3.054-.903-6.108-1.368-9.161-33.086.487-23.25 45.971 17.606 49.481a187.67 187.67 0 0 0 10.164 37.788 78.907 78.907 0 0 0-30.259-21.21c-11.076-3.996-23.54-3.922-35.504-4.758-14.564-1.032-23.205 16.294-13.28 26.99 7.655-4.323 17.3 3.002 12.085 11.175 21.676 16.374 51.952 20.062 77.117 10.067a188.4 188.4 0 0 0 51.26 60.662c-25.94-17.834-54.084 1.805-79.007 10.746a9.114 9.114 0 0 0-2.542 16.49 52.641 52.641 0 0 1 9.814-3.539 7.956 7.956 0 0 1 8.243 12.516c29.516 10.95 64.543 1.621 85.56-21.596a193.688 193.688 0 0 0 36.835 15.974l31.313-34.349c-.27-.471-.562-.941-.843-1.4a52.809 52.809 0 0 1-9.23 8.988c-2.292-17.49-1.442-28.628-19.809-36.407ZM237.143 210.798a5.853 5.853 0 0 0 2.714-10.657l-.63-1.518a15.726 15.726 0 0 1 28.802-4.532c9.235 15.05 20.573 30.368 18.768 48.713 20.045-66.145-1.236-141.599-52.165-188.113-12.888-4.805-24.271-15.044-28.786-28.217 6.194 1.128 12.84-4.756 7.487-10.315-2.273-2.09-4.562-4.16-6.835-6.25 18.883-27.173 51.119 6.389 31.212 42.24a187.67 187.67 0 0 1 25.668 29.535 78.907 78.907 0 0 1-.694-36.946c2.872-11.42 9.894-21.717 15.883-32.107 7.278-12.658 26.476-10.149 29.805 4.058-7.861 3.935-7.172 16.028 2.52 16.266 1.476 27.125-12.375 54.299-34.72 69.59a188.4 188.4 0 0 1 21.69 76.401c-.306-31.478 31.704-43.854 53.039-59.534a9.114 9.114 0 0 1 15.1 7.102 52.641 52.641 0 0 0-8.418 6.163 7.956 7.956 0 0 0 5.779 13.828c-7.403 30.599-34.704 54.444-65.7 58.91a193.688 193.688 0 0 1-7.323 39.476l-45.981 6.79c-.24-.486-.467-.992-.69-1.48a52.81 52.81 0 0 0 12.61-2.637c-13.229-11.67-22.942-17.185-19.137-36.766Z"
        />
        <Path
          fill="#2f2e41"
          d="M283.389 196.054c-20.934 0-32.288-2.558-36.254-8.018-3.499-4.818-1.153-11.175 1.563-18.536 1.952-5.29 4.165-11.286 4.165-17.22 0-28.865 14.636-43.5 43.5-43.5 14.361 0 29.781 7.628 41.248 20.407 10.425 11.617 15.619 25.521 14.249 38.146-1.124 10.354-5.943 17.163-15.167 21.43l-.54.25-.153-.575a24.543 24.543 0 0 0-3.974-8.24 28.198 28.198 0 0 1-2.875 11.173l-.098.198-.213.061c-10.44 2.974-22.83 3.78-32.458 4.149q-7.03.274-12.993.275Z"
        />
        <Path
          fill="#ffb6b6"
          d="M289.094 236.27a15.666 15.666 0 0 0-24.392-7.364l-68.856 41.167-21.547-52.573a15.297 15.297 0 1 0-16.901 6.075c1.328 15.16 8.708 82.921 34.383 80.458 21.581-2.07 75.176-37.763 91.822-50.139a15.668 15.668 0 0 0 5.491-17.623Z"
        />
        <Path
          fill="#2f2e41"
          d="M340.983 535.28h-59.93l-10.05-49.69-3.26 49.69h-55.67a1135.632 1135.632 0 0 1 6.09-116.83l.69-2.35 1.09-3.76.69-2.36 11.52-39.56.91-3.14h69.37a101.545 101.545 0 0 1 11.01 12.16c1.13 1.44 2.31 3 3.52 4.68.84 1.19 1.71 2.44 2.58 3.75a125.997 125.997 0 0 1 17.1 37.6v.01q.915 3.434 1.62 7.03v.01c.42 2.13.79 4.29 1.08 6.5.22 1.61.41 3.24.55 4.89a112.103 112.103 0 0 1-.87 27.42Z"
        />
        <Ellipse
          cx={385.514}
          cy={258.379}
          fill="#e6e6e6"
          rx={7.557}
          ry={5.257}
          transform="rotate(-21.161 -284.702 1142)"
        />
        <Ellipse
          cx={434.517}
          cy={252.093}
          fill="#3f3d56"
          rx={7.557}
          ry={5.257}
          transform="rotate(-21.161 -235.698 1135.713)"
        />
        <Ellipse
          cx={381.264}
          cy={300.187}
          fill="#ff6584"
          rx={7.557}
          ry={5.257}
          transform="rotate(-21.161 -288.952 1183.808)"
        />
        <Ellipse
          cx={367.885}
          cy={318.884}
          fill="#e6e6e6"
          rx={3.322}
          ry={4.776}
          transform="rotate(-13.316 -595.303 1787.578)"
        />
        <Ellipse
          cx={367.594}
          cy={350.106}
          fill="#3f3d56"
          rx={3.322}
          ry={4.776}
          transform="rotate(-13.316 -595.595 1818.8)"
        />
        <Ellipse
          cx={410.603}
          cy={285.437}
          fill="#e6e6e6"
          rx={3.322}
          ry={4.776}
          transform="rotate(-13.316 -552.586 1754.131)"
        />
        <Ellipse
          cx={384.794}
          cy={279.17}
          fill="#ff6584"
          rx={3.322}
          ry={4.776}
          transform="rotate(-13.316 -578.395 1747.864)"
        />
        <Ellipse
          cx={412.149}
          cy={250.419}
          fill="#3f3d56"
          rx={3.322}
          ry={4.776}
          transform="rotate(-13.316 -551.04 1719.113)"
        />
        <Ellipse
          cx={420.218}
          cy={466.266}
          fill="#e6e6e6"
          rx={5.257}
          ry={7.557}
          transform="rotate(-49.595 40.776 769.204)"
        />
        <Ellipse
          cx={391.357}
          cy={426.167}
          fill="#3f3d56"
          rx={5.257}
          ry={7.557}
          transform="rotate(-49.595 11.915 729.105)"
        />
        <Ellipse
          cx={459.006}
          cy={450.096}
          fill="#ff6584"
          rx={5.257}
          ry={7.557}
          transform="rotate(-49.595 79.564 753.034)"
        />
        <Ellipse
          cx={481.817}
          cy={452.958}
          fill="#e6e6e6"
          rx={4.776}
          ry={3.322}
          transform="rotate(-41.75 60.64 839.242)"
        />
        <Ellipse
          cx={509.412}
          cy={438.348}
          fill="#3f3d56"
          rx={4.776}
          ry={3.322}
          transform="rotate(-41.75 88.235 824.632)"
        />
        <Ellipse
          cx={432.066}
          cy={431.32}
          fill="#e6e6e6"
          rx={4.776}
          ry={3.322}
          transform="rotate(-41.75 10.889 817.604)"
        />
        <Ellipse
          cx={438.843}
          cy={456.999}
          fill="#ff6584"
          rx={4.776}
          ry={3.322}
          transform="rotate(-41.75 17.666 843.283)"
        />
        <Ellipse
          cx={400.536}
          cy={446.633}
          fill="#3f3d56"
          rx={4.776}
          ry={3.322}
          transform="rotate(-41.75 -20.641 832.917)"
        />
        <Ellipse
          cx={616.523}
          cy={207.202}
          fill="#e6e6e6"
          rx={5.257}
          ry={7.557}
          transform="rotate(-26.188 42.425 898.874)"
        />
        <Ellipse
          cx={627.079}
          cy={255.467}
          fill="#3f3d56"
          rx={5.257}
          ry={7.557}
          transform="rotate(-26.188 52.98 947.139)"
        />
        <Ellipse
          cx={574.504}
          cy={206.632}
          fill="#ff6584"
          rx={5.257}
          ry={7.557}
          transform="rotate(-26.188 .405 898.304)"
        />
        <Ellipse
          cx={554.707}
          cy={194.943}
          fill="#e6e6e6"
          rx={4.776}
          ry={3.322}
          transform="rotate(-18.343 -192.126 1231.57)"
        />
        <Ellipse
          cx={523.579}
          cy={197.388}
          fill="#3f3d56"
          rx={4.776}
          ry={3.322}
          transform="rotate(-18.343 -223.254 1234.015)"
        />
        <Ellipse
          cx={591.768}
          cy={234.565}
          fill="#e6e6e6"
          rx={4.776}
          ry={3.322}
          transform="rotate(-18.343 -155.065 1271.192)"
        />
        <Ellipse
          cx={595.749}
          cy={208.307}
          fill="#ff6584"
          rx={4.776}
          ry={3.322}
          transform="rotate(-18.343 -151.083 1244.933)"
        />
        <Ellipse
          cx={626.787}
          cy={233.038}
          fill="#3f3d56"
          rx={4.776}
          ry={3.322}
          transform="rotate(-18.343 -120.046 1269.664)"
        />
        <Path
          fill="#7BCBB9"
          d="m273.264 204.09 33.016-1.701 15.335 24.231s28.854 4.824 26.854 38.824-35.106 63.835-35.106 63.835l1.415 17.706-2.458 7.023.315 3.943 3.353 4.176.345 4.319-2.97 6.833 4.04 6.543-84.934-8.229-3.106-11.314 4.53-6.075-2.53-7.925 3.804-7.622 1.984-24.21s-21.704-32.608 3.212-57.168l10-17 11.189-13.651Z"
        />
        <Circle cx={289.678} cy={162.264} r={34.984} fill="#ffb6b6" />
        <Path
          fill="#2f2e41"
          d="M284.994 160.143q-4.522 0-9.04-.255l-.537-.03.07-.534a24.504 24.504 0 0 0-.733-9.973 28.203 28.203 0 0 1-6.873 9.707l-.167.153-.225-.025a172.659 172.659 0 0 1-24.25-4.422l-.305-.078-.061-.31a45.783 45.783 0 0 1-.92-8.877c0-9.316 3.377-17.157 9.51-22.078 6.676-5.357 16.245-7.005 26.955-4.642h34.245a14.216 14.216 0 0 1 14.2 14.2v21.686l-.374.098a163.812 163.812 0 0 1-41.495 5.38Z"
        />
        <Path
          fill="#ccc"
          d="M46.28 121.229a6.164 6.164 0 0 0-3.676 7.893L79.547 230.49a6.164 6.164 0 0 0 7.893 3.676l143.383-52.255a6.164 6.164 0 0 0 3.676-7.893L197.556 72.65a6.164 6.164 0 0 0-7.893-3.676Z"
        />
        <Path
          fill="#fff"
          d="m177.459 195.772-87.765 31.986a6.634 6.634 0 0 1-8.495-3.957L47.692 131.86a6.634 6.634 0 0 1 3.957-8.495l135.28-49.302a6.634 6.634 0 0 1 8.495 3.957l16.19 44.424a57.264 57.264 0 0 1-34.155 73.328Z"
        />
        <Path
          fill="#7BCBB9"
          d="m114.307 129.353-20.856 7.6A2.12 2.12 0 1 1 92 132.97l20.856-7.6a2.12 2.12 0 0 1 1.451 3.983ZM164.028 120.46 96.42 145.1a2.12 2.12 0 1 1-1.452-3.984l67.609-24.64a2.12 2.12 0 0 1 1.451 3.984ZM167.436 129.81l-67.608 24.64a2.12 2.12 0 1 1-1.452-3.984l67.608-24.639a2.12 2.12 0 0 1 1.452 3.983ZM170.844 139.16l-67.609 24.64a2.12 2.12 0 1 1-1.451-3.983l67.608-24.64a2.12 2.12 0 0 1 1.452 3.984ZM174.251 148.511l-67.608 24.64a2.12 2.12 0 1 1-1.452-3.984l67.609-24.639a2.12 2.12 0 0 1 1.451 3.983Z"
        />
        <Path
          fill="#ffb6b6"
          d="m388.773 174.48-37.016 88.58a15.496 15.496 0 0 1-20.071 8.356 15.496 15.496 0 0 1-8.255-20.918l41.271-90.835 22.752-56.25a13.522 13.522 0 1 1 17.288 1.513Z"
        />
      </Svg>
    }
  </View>
)
